import React, { memo, useMemo } from 'react'
import tw from 'twin.macro'
import { RowActionsMenu } from 'src/components/shared/grid/RowActionsMenu'
import type { MenuActionItem } from 'src/interfaces/ui'
import type { Market } from 'src/interfaces/market'
import { GSIcon } from 'src/components/shared/GSIcon'

const DELETE_DISABLED_REASON = 'Deleting a market is not supported by the admin API yet.'

interface Props {
  market: Market
  onEdit(market: Market): void
}

const MarketActionsCellComponent = ({ market, onEdit }: Props) => {
  const items = useMemo<MenuActionItem[]>(() => {
    return [
      {
        label: 'Edit',
        icon: <GSIcon iconName="gs_pencil" size={20} css={tw`text-shades-1000`} />,
        dataTestId: `markets-list-edit-${market.id}`,
        onClick: () => {
          onEdit(market)
        },
      },
      {
        label: 'Delete',
        icon: <GSIcon iconName="gs_trash_can" size={20} css={tw`text-critical-500`} />,
        color: 'var(--mui-critical-500)',
        disabled: true,
        disabledReason: DELETE_DISABLED_REASON,
        dataTestId: `markets-list-delete-${market.id}`,
        onClick: () => {},
      },
    ]
  }, [market, onEdit])

  return (
    <RowActionsMenu
      items={items}
      ariaLabel="Market actions"
      dataTestId={`markets-list-actions-${market.id}`}
    />
  )
}

export const MarketActionsCell = memo(MarketActionsCellComponent)
